import { firebaseApp, cloudFunctions } from "firebase/client";

import { useState } from "react";

export default function useAuth() {
  const [loading, setLoading] = useState(false);

  // El link de ingreso lo genera y manda la Cloud Function (por Resend), no el
  // SDK cliente: sendSignInLinkToEmail usaba el SMTP configurado en la consola
  // de Firebase Auth y fallaba en silencio. Ver sendSignInLinkEmail en functions.
  const sendLinkMail = (userName) => {
    setLoading(true);

    const sendSignInLinkEmail = cloudFunctions.httpsCallable("sendSignInLinkEmail");

    return sendSignInLinkEmail({
      email: userName,
      continueUrl: window.location.origin,
    })
      .then((result) => {
        // AuthContext lee este mail al volver desde el link (signInWithEmailLink).
        window.localStorage.setItem("emailForSignIn", userName);

        return result;
      })
      .catch((error) => {
        if (error.code === "functions/permission-denied") {
          throw "Usuario sin autorización";
        }

        console.error("sendSignInLinkEmail falló:", error);
        throw "No pudimos enviar el mail de ingreso. Intente nuevamente en unos minutos.";
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const signOut = () => {
    setLoading(true);

    let promise = new Promise((resolve, reject) => {
      firebaseApp
        .auth()
        .signOut()
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error.message);
        })
        .finally(() => {
          setLoading(false);
        });
    });

    return promise;
  };

  const createUser = async (userName, displayName, roles, awards) => {
    setLoading(true);

    var createUserFunction = cloudFunctions.httpsCallable("createUser");

    return createUserFunction({
      displayName: displayName,
      email: userName,
      roles,
      awards,
    })
      .then((result) => {
        return result;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateUser = async (uid, email, displayName, roles, awards) => {
    setLoading(true);

    var updateUserFunction = cloudFunctions.httpsCallable("updateUser");

    return updateUserFunction({
      uid,
      displayName: displayName,
      email: email,
      roles,
      awards,
    })
      .then((result) => {
        return result;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteUser = async (uid) => {
    setLoading(true);

    var removeUserRef = cloudFunctions.httpsCallable("removeUser");

    return removeUserRef({ uid })
      .then((result) => {
        return result;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    loading,
    sendLinkMail,
    signOut,
    createUser,
    deleteUser,
    updateUser,
  };
}
